import React, { Component, createRef } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { toPng } from 'html-to-image';
import Logo from '../../images/modallogo.svg';
import { Chatlanguage } from '../../language';
import Share from '../../images/share.svg';
import PostIcon from '../../images/post.svg';
import AdImage from '../../images/ad_image.png';
import Send from '../../images/send.svg';
import Avatar from '../../images/avatar.svg';
import { getLabel } from '../../language';
import {APP_CONFIG} from "../../appconfig";
const apiPath = APP_CONFIG.apiPath;

class ChatModal extends Component {
    constructor(props) {
        super(props);
        this.chatBodyRef = createRef();
        this.modalContentRef = createRef();
        this.state = {
            chatMessages: [],
            newMessage: '',
            name: '',
            country: '',
            language: '',
            error: null,
            toastMessage: '',
            isToastVisible: false,
            messages: [],
            inputMessage: '',
            data: null,
            isBotTyping: false,
            errorMessage: '',
            conversation_id: 1,
            privacy_code: 2, // Default value: "These are just for me"
            donor_name: '',
            donor_location: '',
            donor_website: '',
            donor_message: '',
            hasSponsorData: false, // Flag to track if we have valid sponsor data
            sponsorMessageId: null, // Store the ID of the pollysponsormessage
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.chatMessages.length > prevState.chatMessages.length) {
            this.scrollToBottom();
        }
    }
    componentDidMount() {
        this.fetchLastConversationId();
        
        // Initialize language display based on site language
        const siteLanguage = localStorage.getItem('language') || 'EN';
        const languageName = Chatlanguage.find(language => language.code === siteLanguage)?.language || 'English';
        this.setState({
            language: languageName
        });
    }

    fetchLastConversationId = async () => {
        const { personID, id, typePage } = this.props.polly;
        let entitytype = "person";
        let entityid = personID || id; // Use personID for Polly or id for Organisation

        if (typePage === "Polly") {
            entitytype = "person";
        } else if(typePage === "Organisation"){
            entitytype = "organisation";
        }

        try {
            const response = await axios.get(`${apiPath}/pollytalkhistory/getLastConversationId`, {
                params: {
                    entityid: entityid,
                    entitytype: entitytype,
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("bearerToken")}`,
                },
            });

            if (response.data && response.data.conversation_id !== undefined) {
                this.setState({ conversation_id: response.data.conversation_id }, () => {
                    this.fetchChatHistory();
                });
            } else {
                console.error("Invalid response format for conversation_id:", response.data);
                this.fetchChatHistory(); // Fall back to default conversation_id
            }
        } catch (error) {
            console.error("Error fetching last conversation ID:", error);
            this.fetchChatHistory(); // Fall back to default conversation_id
        }
    };

    fetchChatHistory = async () => {
        const { personID, id, typePage } = this.props.polly;
        let entitytype = "person";
        let entityid = personID || id; // Use personID for Polly or id for Organisation

        if (typePage === "Polly") {
            entitytype = "person";
        } else if(typePage ==="Organisation"){
            entitytype = "organisation";
        }

        const { conversation_id } = this.state;

        try {
            const response = await axios.get(`${apiPath}/pollytalkhistory`, {
                params: {
                    entityid: entityid,
                    entitytype: entitytype,
                    conversation_id: conversation_id,
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("bearerToken")}`,
                },
            });

            if (Array.isArray(response.data)) {
                response.data.reverse().forEach((msg) => {
                    this.setState((prevState) => ({
                        chatMessages: [
                            ...prevState.chatMessages,
                            { sender: "user", text: msg.message, timestamp: msg.timestamp },
                            msg.response && { sender: "bot", text: msg.response, timestamp: msg.timestamp },
                        ].filter(Boolean),
                    }));
                });

                this.scrollToBottom();
            } else {
                console.error("Invalid response format:", response.data);
                // Don't clear messages on invalid response format
            }
        } catch (error) {
            console.error("Error fetching chat history:", error);
            // Don't clear messages on error, only when user explicitly starts new chat
        }
        
        // Fetch sponsor message after chat history
        this.fetchSponsorMessage();
    };
    
    fetchSponsorMessage = async () => {
        const { personID, id, typePage } = this.props.polly;
        let entitytype = "person";
        let entityid = personID || id; // Use personID for Polly or id for Organisation

        if (typePage === "Polly") {
            entitytype = "person";
        } else if(typePage === "Organisation"){
            entitytype = "organisation";
        }

        try {
            const response = await axios.post(
                `${apiPath}/pollysponsormessage`,
                {
                    entityid: entityid,
                    entitytype: entitytype,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("bearerToken")}`,
                    },
                }
            );

            // Check if we have a valid response with sponsor data
            if (response.data && typeof response.data === 'object') {
                const hasSponsorData = !!(response.data.donor_name || response.data.donor_location || 
                    response.data.donor_website || response.data.donor_message);
                
                this.setState({
                    donor_name: response.data.donor_name || '',
                    donor_location: response.data.donor_location || '',
                    donor_website: response.data.donor_website || '',
                    donor_message: response.data.donor_message || '',
                    sponsorMessageId: response.data.id || null, // Store the ID from the response
                    hasSponsorData: hasSponsorData
                });
            } else {
                // No valid sponsor data
                this.setState({
                    hasSponsorData: false,
                    sponsorMessageId: null
                });
            }

            // Sponsor message processing is complete - no need to process messages here
        } catch (error) {
            console.error("Error fetching sponsor message:", error);
            // Don't clear messages on error, only when user explicitly starts new chat
            this.setState({
                hasSponsorData: false
            });
        }
    };

    handleStartNewChat = () => {
        this.setState(
            (prevState) => ({
                conversation_id: prevState.conversation_id + 1,
                chatMessages: [],
                inputMessage: '',
            }),
            () => {
                this.fetchChatHistory();
            }
        );
    };

    scrollToBottom = () => {
        const chatBody = this.chatBodyRef.current;
        if (chatBody) {
            chatBody.scrollTop = chatBody.scrollHeight;
        }
    };
    handleInputChange = (e) => {
        const { value } = e.target;
        this.setState({ inputMessage: value });

        if (value.trim()) {
            clearTimeout(this.typingTimeout);
            this.typingTimeout = setTimeout(() => {
                this.setState({ isBotTyping: false });
            }, 4000);
        } else {
            this.setState({ isBotTyping: false });
        }
    };

    handleSendMessage = async () => {
        const { inputMessage, chatMessages, privacy_code, language: languageName } = this.state;
        const { personID, id, displayName, lastTermTitle, typePage } = this.props.polly;
        
        // Find the language code that corresponds to the selected language name
        const languageEntry = Chatlanguage.find(lang => lang.language === languageName);
        const language = languageEntry ? languageEntry.code : (localStorage.getItem('language') || 'EN');
        
        const {conversation_id} =this.state
        let entitytype = "person";
        let entityid = personID || id; // Use personID for Polly or id for Organisation

        if (typePage === "Polly") {
            entitytype = "person";
        } else if(typePage ==="Organisation"){
            entitytype = "organisation";
        }
        if (!inputMessage.trim()) return;

        const newMessage = { text: inputMessage, sender: 'user' };
        this.setState({ chatMessages: [...chatMessages, newMessage], inputMessage: '' ,isBotTyping: true });

        try {
            const token = localStorage.getItem('bearerToken');

            const response = await axios.post(
                `${apiPath}/pollytalk`,
                {
                    entityid: entityid,
                    entitytype: entitytype,
                    entity_name: displayName,
                    entity_description: lastTermTitle,
                    language_field: language,
                    message: inputMessage,
                    conversation_id:conversation_id,
                    privacy_code: privacy_code,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // Call mark-donation-sponsor-complete API after successful pollytalk response
            if (this.state.sponsorMessageId) {
                await this.markDonationSponsorComplete();
            }

            const botReply = { text: response.data.reply || 'No response', sender: 'bot' };
            this.setState((prevState) => ({
                chatMessages: [...prevState.chatMessages, botReply],
                isBotTyping: false,
            }), () => {
                // Call fetchSponsorMessage after state update is complete
                this.fetchSponsorMessage();
            });
        } catch (error) {
            console.error('Error fetching response:', error);
            this.setState({
                errorMessage: 'Something went wrong. Please try again later.',
                isBotTyping: false,
            });
        }
    };

    handleShareClick = async () => {
        if (this.modalContentRef.current) {
            try {
                const modalContent = this.modalContentRef.current;
                
                // Store original styles
                const originalMaxHeight = modalContent.style.maxHeight;
                const originalOverflow = modalContent.style.overflow;
                const originalWidth = modalContent.style.width;
                const originalPosition = modalContent.style.position;
                const originalDisplay = modalContent.style.display;
                
                // Set styles for capturing
                modalContent.style.maxHeight = 'none';
                modalContent.style.overflow = 'visible';
                modalContent.style.width = '1000px';
                modalContent.style.position = 'relative';
                modalContent.style.display = 'block';
                
                // Make sure all child elements are visible
                const chatBody = this.chatBodyRef.current;
                const originalChatMaxHeight = chatBody.style.maxHeight;
                const originalChatOverflow = chatBody.style.overflow;
                chatBody.style.maxHeight = 'none';
                chatBody.style.overflow = 'visible';

                // Capture the image with increased dimensions
                const dataUrl = await toPng(modalContent, {
                    canvasWidth: Math.max(modalContent.scrollWidth, 1000),
                    canvasHeight: Math.max(modalContent.scrollHeight, 1000),
                    pixelRatio: 2, // Higher quality
                    useCORS: true,
                });

                // Restore original styles
                modalContent.style.maxHeight = originalMaxHeight;
                modalContent.style.overflow = originalOverflow;
                modalContent.style.width = originalWidth;
                modalContent.style.position = originalPosition;
                modalContent.style.display = originalDisplay;
                
                // Restore chat body styles
                chatBody.style.maxHeight = originalChatMaxHeight;
                chatBody.style.overflow = originalChatOverflow;
                
                if (!window.ClipboardItem) {
                    alert("Clipboard image copying is not supported in your browser.");
                    return;
                }

                const response = await fetch(dataUrl);
                const blob = await response.blob();
                const clipboardItem = new window.ClipboardItem({ "image/png": blob });

                await navigator.clipboard.write([clipboardItem]);
                this.showToast('Image successfully copied to clipboard! Paste it wherever you want to share it!');
            } catch (error) {
                console.error("Error capturing chat body:", error);
                this.showToast('Failed to copy image. Please try again.');
            }
        }
    };

    handleDownloadClick = async () => {
        if (this.modalContentRef.current) {
            try {
                const modalContent = this.modalContentRef.current;
                
                // Store original styles
                const originalMaxHeight = modalContent.style.maxHeight;
                const originalOverflow = modalContent.style.overflow;
                const originalWidth = modalContent.style.width;
                const originalPosition = modalContent.style.position;
                const originalDisplay = modalContent.style.display;
                
                // Set styles for capturing
                modalContent.style.maxHeight = 'none';
                modalContent.style.overflow = 'visible';
                modalContent.style.width = '1000px';
                modalContent.style.position = 'relative';
                modalContent.style.display = 'block';
                
                // Make sure all child elements are visible
                const chatBody = this.chatBodyRef.current;
                const originalChatMaxHeight = chatBody.style.maxHeight;
                const originalChatOverflow = chatBody.style.overflow;
                chatBody.style.maxHeight = 'none';
                chatBody.style.overflow = 'visible';

                // Capture the image with increased dimensions
                const dataUrl = await toPng(modalContent, {
                    canvasWidth: Math.max(modalContent.scrollWidth, 1000),
                    canvasHeight: Math.max(modalContent.scrollHeight, 1000),
                    pixelRatio: 2, // Higher quality
                    useCORS: true,
                });

                // Restore original styles
                modalContent.style.maxHeight = originalMaxHeight;
                modalContent.style.overflow = originalOverflow;
                modalContent.style.width = originalWidth;
                modalContent.style.position = originalPosition;
                modalContent.style.display = originalDisplay;
                
                // Restore chat body styles
                chatBody.style.maxHeight = originalChatMaxHeight;
                chatBody.style.overflow = originalChatOverflow;

                const link = document.createElement('a');
                link.href = dataUrl;
                link.download = 'chat-screenshot.png';
                link.click();
                this.showToast('Image downloaded successfully!');
            } catch (error) {
                console.error('Error capturing chat body:', error);
                this.showToast('Failed to capture image. Please try again.');
            }
        }
    };
    
    showToast = (message) => {
        this.setState({ toastMessage: message, isToastVisible: true });
        setTimeout(() => {
            this.setState({ isToastVisible: false });
        }, 100);
    };

    toggleEdit = () => {
        this.setState((prevState) => ({ isEditing: !prevState.isEditing }));
    };

    handleChangeField = (event) => {
        const { name, value } = event.target;
        this.setState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    handleSubmit = () => {
        // Get the selected language from the dropdown
        const selectedLanguage = document.querySelector('select[name="language"]')?.value || localStorage.getItem('language') || 'EN';
        const languageName = Chatlanguage.find(language => language.code === selectedLanguage)?.language || 'English';

        this.setState({
            name: this.state.tempName,
            country: this.state.tempCountry,
            language: languageName,
            isEditing: false,
        });
    };

    handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.handleSendMessage();
        }
    };

    handlePrivacyChange = (event) => {
        this.setState({
            privacy_code: parseInt(event.target.value, 10)
        });
    };

    releaseSponsorMessage = async () => {
        const { sponsorMessageId } = this.state;
        
        if (!sponsorMessageId) {
            console.log("No sponsor message ID available, skipping release-pollysponsormessage API call");
            return;
        }
        
        try {
            await axios.post(
                `${apiPath}/release-pollysponsormessage`,
                {
                    id: sponsorMessageId,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("bearerToken")}`,
                    },
                }
            );
            console.log("Successfully released sponsor message");
        } catch (error) {
            console.error("Error releasing sponsor message:", error);
        }
    };

    markDonationSponsorComplete = async () => {
        const { sponsorMessageId } = this.state;
        
        if (!sponsorMessageId) {
            console.log("No sponsor message ID available, skipping mark-donation-sponsor-complete API call");
            return;
        }
        
        try {
            await axios.post(
                `${apiPath}/mark-donation-sponsor-complete`,
                {
                    id: sponsorMessageId,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("bearerToken")}`,
                    },
                }
            );
            console.log("Successfully marked donation sponsor complete");
        } catch (error) {
            console.error("Error marking donation sponsor complete:", error);
        }
    };
    render() {
        const { chatMessages, inputMessage, isToastVisible, toastMessage, isBotTyping  } = this.state;
        const { show, onClose, polly, displayLocation,Name} = this.props;
        const { displayName, photoName, personID ,typePage} = polly;

        return (
            <Modal show={show} onHide={() => {
                this.releaseSponsorMessage();
                onClose();
            }} bsSize="large" className="polly-modal">
                <div id="votepopup" className="custom-modal-overlay">
                    {isToastVisible && <div className="toast-notification">{toastMessage}</div>}

                    <div className="modal-new-content" ref={this.modalContentRef}>
                        <button className="close-model-button" onClick={() => {
                            this.releaseSponsorMessage();
                            onClose();
                        }}>
                            X
                        </button>
                        <div className="modal_hedaer">
                            <div className="modal_logo">
                                <img src={Logo} alt="logo" className="logo_image" />
                            </div>
                        </div>

                        <div className="row new-modal-header">
                            <div className="col-lg-2 col-md-3 col-sm-12 col-12 modal_image">
                                <img
                                    onError={(e) => (e.target.src = Avatar)}
                                        src={photoName ? `/images/people/${personID}/official/${photoName}` : Avatar}
                                    alt={displayName}
                                    title={displayName}
                                    className="img-fluid model-image-round"
                                />
                            </div>
                            <div className="col-lg-10 col-md-9 col-sm-12 col-12 text-md-left">
                                <h2 className="model-chat-name">
                                    <span className="text_lable">{getLabel(489)} {displayName}</span>
                                </h2>
                                <div className="model_des">{getLabel(491)}</div>
                                <div className="model_text">
                                    <div className="text_des" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <p style={{ margin: 0 }}>
                                            I am {this.state.name || Name} from {this.state.country || displayLocation}, let's chat in {this.state.language}.
                                        </p>
                                        <span className="Change_btn" onClick={this.toggleEdit}>Change</span>
                                    </div>

                                    <div className={`edit-mode-container ${this.state.isEditing ? 'show' : ''}`}>
                                        {this.state.isEditing && (
                                            <div className="row edit-mode">
                                                <div className="col-12 col-md-6 col-lg-3 edit-data">
                                                    <span>I am </span>
                                                    <input
                                                        type="text"
                                                        name="tempName"
                                                        value={this.state.tempName !== undefined ? this.state.tempName : Name}
                                                        onChange={this.handleChangeField}
                                                        className="input-box"
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-3 edit-data">
                                                    <span style={{ marginRight: '7px' }}>from</span>
                                                    <input
                                                        type="text"
                                                        name="tempCountry"
                                                        value={this.state.tempCountry !== undefined ? this.state.tempCountry : displayLocation}
                                                        onChange={this.handleChangeField}
                                                        className="select-box"
                                                    />
                                                </div>
                                                <div className="col-12 col-md-8 col-lg-4 edit-data" style={{ width: '100%' }}>
                                                    <span>Let's talk in</span>
                                                    <select
                                                        name="language"
                                                        defaultValue={localStorage.getItem('language') || 'EN'}
                                                        className="select-box"
                                                    >
                                                        {Chatlanguage.map((language) => (
                                                            <option key={language.code} value={language.code}>
                                                                {language.language}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-1">
                                                    <button onClick={this.handleSubmit} className="submit-btn">Submit</button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row chat_data">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 chat_section">
                                <div className="chatimage">
                                    <div className="chat-body" ref={this.chatBodyRef}>
                                        {chatMessages.length > 0 ? (
                                            chatMessages.map((msg, index) => {
                                                return (
                                                    <div key={index} className={`chat-message ${msg.sender === 'user' ? 'right-message' : 'left-message'}`}>
                                                        {msg.sender === 'bot' && (
                                                            <img
                                                                onError={(e) => (e.target.src = Avatar)}
                                                                src={photoName ? `/images/people/${personID}/official/${photoName}` : Avatar}
                                                                alt="Bot"
                                                                className="chat-avatar"
                                                            />
                                                        )}
                                                        <div className={`message-bubble ${msg.sender === 'user' ? 'right-bubble' : 'left-bubble'}`}>
                                                            {msg.text}
                                                        </div>
                                                        {msg.sender === 'user' && (
                                                            <img
                                                                onError={(e) => (e.target.src = Avatar)}
                                                                src={Avatar}
                                                                alt="User"
                                                                className="chat-avatar"
                                                            />
                                                        )}
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <></>
                                        )}

                                        {isBotTyping && (
                                            <div className="typing-indicator">
                                                <div className="dots">
                                                    <span className="dot"> </span>
                                                    <span className="dot"> </span>
                                                    <span className="dot"> </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>


                                    <div className="chat-footer">
                                        <textarea
                                            placeholder={`Message ${displayName}`}
                                            className="chat-input resize-none overflow-y-auto"
                                            value={inputMessage}
                                            onChange={this.handleInputChange}
                                            onKeyDown={this.handleKeyDown}
                                        />

                                        <button className="send-btn" onClick={this.handleSendMessage}>
                                            <img src={Send} alt="Send" />
                                        </button>
                                    </div>

                                    {this.state.errorMessage && (
                                        <div className="error-message" style={{ color: 'red', margin: '5px 0px 20px 11px' }}>
                                            {this.state.errorMessage}
                                        </div>
                                    )}
                                </div>
                                <p className="modal_hedaer_text">
                                    This chat is brought to you by <a href="https://politiq.net">politiq.net</a>
                                </p>
                            </div>

                            <div className="col-lg-3 col-md-4 col-sm-12 col-12 chat-container">
                                <div className="sponsor-section">
                                    <p className="sponsor-text">This chat is brought to you by</p>
                                    {this.state.hasSponsorData ? (
                                        <div className="sponsor-info">
                                            <p>Name: {this.state.donor_name || "Anonymous"}</p>
                                            {this.state.donor_location && <p>From: {this.state.donor_location}</p>}
                                            <p>Link: <a href={this.state.donor_website} target="_blank" rel="noopener noreferrer">{this.state.donor_website}</a></p>
                                            <p>{this.state.donor_message}</p>
                                            <div className="sponsor-info-youtoo">
                                                <p>Want to sponsor too? Click here</p>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="sponsor-info">
                                            <p>You... you could sponsor this chat</p>
                                        </div>
                                    )}
                                </div>

                                <div className="topics-section">
                                    <p className="topics-heading">Not sure what to ask them about? Try these relevant topics</p>
                                    <ul className="topics-list">
                                        <li><a href="#">Corruption charges</a></li>
                                        <li><a href="#">The war in Gaza</a></li>
                                        <li><a href="#">Ceasefire</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="share-section">
                            <button className="share-btn" onClick={this.handleShareClick}>
                                <img className="icon" src={Share} alt="Share" />
                                Share
                            </button>
                            <button className="post-btn" onClick={this.handleDownloadClick}>
                                <img className="post_icon" src={PostIcon} alt="Post" />
                                Post this conversation
                            </button>
                            <button className="restart-chat" onClick={this.handleStartNewChat}>
                                {getLabel(492)}
                            </button>
                            
                            <fieldset className="form-group privacy-list" style={{ 
                                display: 'inline-block', 
                                verticalAlign: 'middle',
                                padding: '0',
                                margin: '0',
                                background: 'transparent',
                                position: 'absolute',
                                right: '20px'
                            }}>
                                <label style={{ 
                                    fontWeight: 'normal', 
                                    marginBottom: '1px', 
                                    color: 'white',
                                    fontSize: '0.85em',
                                    display: 'block'
                                }}>Privacy code:</label>
                                <div className="form-check" style={{ margin: '-2px 0', padding: '0' }}>
                                    <input 
                                        type="radio"
                                        className="form-check-input"
                                        name="privacy_code"
                                        id="privacy_code0"
                                        value="0"
                                        checked={this.state.privacy_code === 0}
                                        onChange={this.handlePrivacyChange}
                                    />
                                    <label className="form-check-label" htmlFor="privacy_code0" style={{ 
                                        color: 'white',
                                        fontSize: '0.8em'
                                    }}>Everyone can see these</label>
                                </div>
                                <div className="form-check" style={{ margin: '-2px 0', padding: '0' }}>
                                    <input 
                                        type="radio"
                                        className="form-check-input"
                                        name="privacy_code"
                                        id="privacy_code1"
                                        value="1"
                                        checked={this.state.privacy_code === 1}
                                        onChange={this.handlePrivacyChange}
                                    />
                                    <label className="form-check-label" htmlFor="privacy_code1" style={{ 
                                        color: 'white',
                                        fontSize: '0.8em'
                                    }}>Only {displayName} can see these</label>
                                </div>
                                <div className="form-check" style={{ margin: '-2px 0', padding: '0' }}>
                                    <input 
                                        type="radio"
                                        className="form-check-input"
                                        name="privacy_code"
                                        id="privacy_code2"
                                        value="2"
                                        checked={this.state.privacy_code === 2}
                                        onChange={this.handlePrivacyChange}
                                    />
                                    <label className="form-check-label" htmlFor="privacy_code2" style={{ 
                                        color: 'white',
                                        fontSize: '0.8em'
                                    }}>These are just for me</label>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ChatModal;
